import React, { useState } from 'react';
import RACES from '../../data/races';

import { btnStyle } from '../../styles/theme';

import CharacterCard from "./CharacterCard";

// ─── CHARACTER LIBRARY MODAL ────────────────────────────────────────────────
function CharacterLibraryModal({ savedCharacters, onLoad, onDelete, onExport, onImport, onClose }) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredCharacters = savedCharacters.filter(saved =>
    saved.character.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    RACES.find(r => r.id === saved.character.race)?.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.85)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "20px"
    }}>
      <div style={{
        background: "linear-gradient(180deg, #1a1510, #0f0c0a)",
        border: "2px solid #c9a84c",
        borderRadius: 12,
        maxWidth: 900,
        width: "100%",
        maxHeight: "90vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 0 40px rgba(201,168,76,0.3)"
      }}>
        {/* Header */}
        <div style={{
          padding: "20px 24px",
          borderBottom: "1px solid rgba(201,168,76,0.3)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <div>
            <div style={{ fontFamily: "'Cinzel Decorative', cursive", fontSize: "24px", color: "#c9a84c" }}>
              Character Library
            </div>
            <div style={{ fontSize: "12px", color: "#8a7e5e", marginTop: 4 }}>
              {savedCharacters.length} character{savedCharacters.length !== 1 ? 's' : ''} saved
            </div>
          </div>
          <button onClick={onClose} style={{
            background: "none",
            border: "2px solid #c0392b",
            color: "#c0392b",
            fontSize: "24px",
            width: 40,
            height: 40,
            borderRadius: "50%",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>×</button>
        </div>

        {/* Search & Import */}
        <div style={{ padding: "16px 24px", borderBottom: "1px solid rgba(201,168,76,0.2)" }}>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
            <input
              type="text"
              placeholder="Search by name or race..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                flex: 1,
                minWidth: 200,
                background: "rgba(0,0,0,0.4)",
                border: "1px solid rgba(201,168,76,0.3)",
                borderRadius: 6,
                padding: "8px 12px",
                color: "#e8dcc8",
                fontSize: "14px"
              }}
            />
            <label style={{ ...btnStyle("#8e44ad", "rgba(142,68,173,0.15)"), padding: "8px 16px", cursor: "pointer" }}>
              📁 Import JSON
              <input type="file" accept=".json" onChange={onImport} style={{ display: "none" }} />
            </label>
          </div>
        </div>

        {/* Character List */}
        <div style={{ flex: 1, overflow: "auto", padding: "16px 24px" }}>
          {filteredCharacters.length === 0 ? (
            <div style={{ textAlign: "center", padding: "40px 20px", color: "#6b6048" }}>
              <div style={{ fontSize: "48px", marginBottom: 12 }}>📜</div>
              <div style={{ fontSize: "16px", marginBottom: 8 }}>
                {searchTerm ? "No characters found" : "No saved characters yet"}
              </div>
              <div style={{ fontSize: "12px" }}>
                {searchTerm ? "Try a different search term" : "Create a character and save it from the Character Details view"}
              </div>
            </div>
          ) : (
            <div style={{ display: "grid", gap: 12 }}>
              {filteredCharacters.map(saved => (
                <CharacterCard
                  key={saved.id}
                  saved={saved}
                  onLoad={onLoad}
                  onDelete={onDelete}
                  onExport={onExport}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CharacterLibraryModal
